/** GP practices whose PCN has not signed up to WorkWell.
 *
 * WorkWell was offered to LLR practices at PRIMARY CARE NETWORK level, not
 * practice by practice, so when a PCN opts out every practice in it opts out
 * together. Three of the 26 LLR PCNs did not sign (Malany, 13 Aug 2026).
 *
 * Keyed on ODS code rather than name: names in our baked list carry the GP
 * partner's name ("Highfields Surgery (R Wadhwa)") while the source list does
 * not, and two unrelated practices can share a leading word. LE2 0NN
 * "Highfields Surgery" is in an opted-out PCN; LE5 3GH "Highfields Medical
 * Centre" is in Leicester Central and stays — name matching would have been a
 * coin toss between them.
 *
 * Every entry was verified against the NHS ODS directory
 * (directory.spineservices.nhs.uk, RE8 → RO272 = current PCN membership) on
 * 14 Aug 2026, in both directions: all 13 sit in the PCN named below, and none
 * of the other 115 practices in our list belongs to an opted-out PCN.
 *
 * WHEN A PCN SIGNS UP: delete its whole block. Do not remove individual
 * practices — membership is what determines eligibility, so a partial removal
 * would leave the list inconsistent with the reason it exists.
 */
export const EXCLUDED_PRACTICE_ODS: ReadonlySet<string> = new Set([
  // --- ACROSS LEICESTER PCN (City — opted out) -----------------------------
  // Branch sites (Beumont Lodge Surgery, Parker Drive Surgery) are not in our
  // list: residents register with the practice, so excluding the parent covers
  // the branch.
  "C82094", // Beaumont Lodge Medical Practice
  "C82086", // Fosse Medical Centre (Dr H Mukadam)
  "C82116", // Highfields Surgery (R Wadhwa)
  "C82018", // Manor Park Medical Practice

  // --- G3 PCN (County — opted out) -----------------------------------------
  "C82005", // Groby Road Medical Centre (Id Patchett)
  "C82628", // Groby Surgery
  "C82056", // The Glenfield Surgery

  // --- ORION PCN (City — opted out) ----------------------------------------
  // Westend Medical Practice Colwell Road is a branch — see the note above.
  "C82092", // Aylestone Health Centre
  "C82107", // Cossington Park Surgery
  "C82620", // Dr S Shafi
  "C82059", // Westcotes GP Surgery (One)
  "C82653", // Westcotes GP Surgery (Two)
  "C82639", // Westend Medical Practice
]);
